import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '预采购',
    type: 2,
    labelClass: 'blue',
    labelName: '预',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'details',
        fieldName: '渲染列表',
        config: {},
        id: 0,
        list: [
          {
            componentType: 'el-select',
            componentName: '下拉选择',
            fieldKey: 'materialId',
            fieldName: '材料',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            option: [],
            config: {
              collapseTags: true,
              isDisabled: false,
              multiple: false,
              clearable: true,
              url: 'material/page?size=999',
              pickerType: '',
              filterable: true,
              selectType: 2// 1本地2远程
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'amount',
            fieldName: '预购数量',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }
        ]
      }
    ]
  }
]
